import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { DepositPageVarsBanner } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import * as Rx from 'rxjs';
import {
  FinopsResult,
  FinopsResultStatus,
} from '../../common/finops-messaging/finops-messaging.types';
import { FinopsTrackingService } from '../../common/finops-tracking/finops-tracking.service';
import {
  ApplicationType,
  DepositContext,
  DepositModalItem,
} from '../../common/types';

@Component({
  template: `
    <app-payment-verify
      class="PaymentVerifyModalContainer"
      flTrackingSection="{{ section }}"
      [depositContext$]="depositContext$"
      (depositResult)="handleDepositResult($event)"
    ></app-payment-verify>
    <fl-heartbeat-tracking
      name="webAppVerificationModal"
    ></fl-heartbeat-tracking>
  `,
  styleUrls: ['./payment-verify-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentVerifyModalComponent implements OnInit {
  depositContext$: Rx.Observable<DepositContext>;
  section = ApplicationType.VERIFICATION_MODAL;

  @Input() backUrl?: string;
  @Input() banner?: DepositPageVarsBanner;
  @Input() items?: ReadonlyArray<DepositModalItem>;
  @Input() trackingToken?: string;

  constructor(
    private modalRef: ModalRef<PaymentVerifyModalComponent>,
    private finopsTracking: FinopsTrackingService,
  ) {}

  ngOnInit() {
    this.finopsTracking.initiate(this.section);
    this.depositContext$ = Rx.of({
      trackingToken: this.trackingToken,
      banner: this.banner || {},
      items: this.items || [],
      backUrl: this.backUrl,
      applicationType: this.section,
      checkBalance: false,
      onSuccess: () => this.close({ finopsStatus: FinopsResultStatus.SUCCESS }),
    });
  }

  close(
    depositResult: FinopsResult = {
      finopsStatus: FinopsResultStatus.INTERRUPTED,
    },
  ) {
    // we can pass the whole object if we need to
    this.modalRef.close(depositResult.finopsStatus);
  }

  handleDepositResult(depositResult: FinopsResult) {
    this.close(depositResult);
  }
}
